const API = "https://money-tracker-1-srbo.onrender.com";
export default API;